import { DataFileImportFormType } from "../DataFileImportEditorUtils";
import { useFormContext } from "react-hook-form";
import { Box } from "@mui/material";
import { useDataFileImportTagTypeMap } from "../../../../queries/data-file-import/UseDataFileImportTagTypeMap";
import { useQueryNotifications } from "../../../../queries/UseQueryNotifications";
import DataFileImportItemList from "../data-file-import-item-list/DataFileImportItemList";
import { useEffect, useMemo } from "react";
import { ItemMapFormType } from "../DataFileImportEditorUtils";
import { IKeyValuePair } from "../../../../common/models/KeyValuePair";
import LoadingZone from "../../../../components/loading-zone/LoadingZone";
import { IeLynxObject } from "../../../../common/models/eLynxObject";
import { eLynxObjectTypeEnum } from "../../../../common/enums/eLynxObjectType";
import { SetPointEventTypeEnum } from "../../../../common/enums/SetPointEventTypeEnum";

export type DataProps = {
     groupID: number,
};

export default function Data({
    groupID
}: DataProps) {

    const {
        //getValues,
        watch,
        //trigger,
        //control,
        //reset,
        setValue,
        //resetField
    } = useFormContext<DataFileImportFormType>();    
    
    const [
        columns,
        fileHasHeaderRow,
        importObjectType,
        importType,
        objectMap,
        dateColumn,
        identifierColumn,
        timeColumn,
        tagTypeMap
    ] = watch([
        'columns',
        'fileHasHeaderRow',
        'importObjectType',
        'importType',
        'objectMap',
        'dateColumn',
        'identifierColumn',
        'timeColumn',
        'tagTypeMap'
    ]);

    const objects = objectMap.map(o => {
        return {
            id: o.id,
            objectType: o.objectType

        } as IeLynxObject;
    });

    const tagTypeColumns = columns.filter(o => o.name !== dateColumn.name &&
                                            o.name !== timeColumn?.name &&
                                            o.name !== identifierColumn?.name);


    const { data, status } = useQueryNotifications(useDataFileImportTagTypeMap)({
        groupID,
        fileHasHeaderRow,
        importObjectType,
        importType,
        tagTypeColumns,
        objects,
        enabled: tagTypeColumns.length > 0
    });

    // const {
    //     fields,
    //     insert,
    //     append,
    //     //remove:
    //     update
    // } = useFieldArray({
    //     control: control,
    //     name: 'tagTypeMap',
    //     keyName: "fieldKey"
    // });    

    const pickList = useMemo(() => {

        return data?.tagTypes.map(o => {
            return {
                Key: o.id,
                Value: o.name
            } as IKeyValuePair<number, string>
        }) ?? [];

    }, [data?.tagTypes]);

    useEffect(() => {
        if (data && (tagTypeMap.length !== data.tagTypeMap.length || tagTypeMap.length === 0)) {

            const listData = data.tagTypeMap.map(o => {
                return {
                    column: o.importColumn.name,
                    id: o.mappedTagType.id,
                    objectType: eLynxObjectTypeEnum.Tag,
                    name: o.mappedTagType.name,
                    eventType: o.eventType
                } as ItemMapFormType;
            });

            listData.forEach(o => {
                const item = tagTypeMap.find(v => v.column === o.column);
                if (item) {
                    o.id = item.id;
                    o.objectType = item.objectType;
                    o.name = item.name;
                    o.guid = item.guid;
                    o.eventType = item.eventType ?? SetPointEventTypeEnum.Imported
                }
            });

            setValue('tagTypeMap', 
                    listData, {
                        shouldDirty: true,
                        shouldValidate: true
                    });
        }
    }, [
        data,
        tagTypeMap,
        setValue,
    ]);

   return (

        <Box sx={{
            display:'flex',
            overflow: "hidden",
            flexDirection: 'column',
            flex: '1 1 auto',
            //overflowY: 'auto',
            padding: 1,
            //height: '100%',
            backgroundColor: "custom.background.cardContainer",
        }}>

            <LoadingZone isLoading={status === 'loading'}>

                {
                status === 'success' && 
                <DataFileImportItemList 
                    name='tagTypeMap' 
                    pickList={pickList} 
                />
                }

            </LoadingZone>

        </Box>
   );
}
